module.exports = __webpack_public_path__ + "components/flag/static/square/lt-9ec22534cf1734041c636e7f9ee76fd5.svg";